export const FEED_AUTHORS = [
  'hive-144726',
  'leothreads',
  'peak.snaps',
  'ecency.waves',
  'liketu.moments',
  'slothbuzz.hangs',
  'sportsbites',
  'hive-grove'
];

export const FEED_MAP = {
  'hive-144726': 'flex',
  'peak.snaps': 'snaps',
  'leothreads': 'threads',
  'ecency.waves': 'waves',
  'slothbuzz.hangs': 'hangs',
  'liketu.moments': 'moments',
  'sportsbites': 'bites',
  'hive-grove': 'sparks'
};

// Shared frontend metadata for selectable short feeds.
export const FEED_DISPLAY_CONFIG = {
  flex: { label: 'Flex', inlineLabel: 'Flex', postLabel: 'Flex it', icon: '🔥', root_author: 'hive-144726', charLimit: 300, showOnProfile: true, enabledByDefault: true },
  threads: { label: 'Threads', inlineLabel: 'Thread', postLabel: 'Thread', icon: '🦁', root_author: 'leothreads', charLimit: 240, showOnProfile: true, enabledByDefault: true },
  snaps: { label: 'Snaps', inlineLabel: 'Snap', postLabel: 'Snap', icon: '📸', root_author: 'peak.snaps', charLimit: 240, showOnProfile: true, enabledByDefault: true },
  waves: { label: 'Waves', inlineLabel: 'Wave', postLabel: 'Wave', icon: '🌊', root_author: 'ecency.waves', charLimit: 240, showOnProfile: true, enabledByDefault: true },
  hangs: { label: 'Hangs', inlineLabel: 'Hang', postLabel: 'Hang', icon: '🦥', root_author: 'slothbuzz.hangs', charLimit: 280, showOnProfile: true, enabledByDefault: true },
  bites: { label: 'Bites', inlineLabel: 'Bite', postLabel: 'Post Bite', icon: '🍔', root_author: 'sportsbites', charLimit: 240, showOnProfile: true, enabledByDefault: true },
  sparks: { label: 'Sparks', inlineLabel: 'Spark', postLabel: 'Post Spark', icon: '🔥', root_author: 'hive-grove', charLimit: 380, showOnProfile: true, enabledByDefault: true },
  moments: { label: 'Moments', inlineLabel: 'Moment', postLabel: 'Post Moment', icon: '⏱️', root_author: 'liketu.moments', charLimit: 240, showOnProfile: true, enabledByDefault: false },
  global: { label: 'Global', inlineLabel: 'Global', postLabel: 'Post', icon: '🌍', root_author: null, charLimit: 280, showOnProfile: false, enabledByDefault: false, isAggregate: true }
};

export const DEFAULT_FEED_KEY = 'flex';

export const getFeedCharacterLimit = (feedKey) => {
  const key = (feedKey || DEFAULT_FEED_KEY).toLowerCase();
  return FEED_DISPLAY_CONFIG[key]?.charLimit || FEED_DISPLAY_CONFIG[DEFAULT_FEED_KEY].charLimit;
};

export const getDefaultEnabledFeedKeys = () => Object.entries(FEED_DISPLAY_CONFIG)
  .filter(([, config]) => config?.enabledByDefault)
  .map(([key]) => key);

export const getFeedKeyByAuthor = (author) => FEED_MAP[String(author || '').toLowerCase()] || null;

export const getFeedDisplayByAuthor = (author) => {
  const key = getFeedKeyByAuthor(author);
  if (!key) return { key: null, label: '', path: '/' };
  return {
    key,
    label: FEED_DISPLAY_CONFIG[key]?.label || '',
    path: `/feed/${key}`,
  };
};
